import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { useAuth } from '../context/AuthContext'

const ModalActions = styled(DialogActions)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(2),
}))

// Shown when the Auth0 session belongs to a soft-deleted account (the API
// answers 403 on /users/me). Blocking on purpose: the account can't use the
// site, and the logout button is the only way to switch to another account.
const DeletedAccountModal = () => {
  const { isDeletedAccount, logout } = useAuth()

  return (
    <Dialog open={isDeletedAccount} maxWidth='xs' fullWidth>
      <DialogTitle>This account has been deleted</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The account you signed in with was deleted and is currently disabled.
          If this was you and you'd like it back, contact support and we'll
          reopen it - your data is still safe.
        </DialogContentText>
      </DialogContent>
      <ModalActions>
        <Button
          href='mailto:support@movieception.com?subject=Reopen%20my%20account'
          variant='outlined'
        >
          Contact Support
        </Button>
        <Button onClick={logout} variant='contained'>
          Log Out & Switch Account
        </Button>
      </ModalActions>
    </Dialog>
  )
}

export default DeletedAccountModal
